import toolRawStyles from './geo_bar_tool'

export const rawStyles = { ...toolRawStyles,
    muiFormControl: {
        flexGrow: 1,
    },
}

export default rawStyles
